import { useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { loadListViewPreferences } from '../api'
import { useSelector } from 'react-redux'
import { selectListViewPreferencesStatus } from '../slice'

export const useLoadListViewPreferencesOnce = () => {
  const dispatch = useAppDispatch()

  const status = useSelector(selectListViewPreferencesStatus)

  useEffect(() => {
    const execute = async () => {
      try {
        await dispatch(loadListViewPreferences())
      } catch {}
    }
    status === 'idle' && execute()
  }, [dispatch, status])

  return status === 'pending'
}
